import styled from 'styled-components'
import { Typography } from 'common/typography'
import CommentForm from 'components/comment/form/'
import CommentList from 'components/comment/comment-list'
import NoComments from 'components/comment/no-comments'
import participants from 'components/comment/participants.json'

const CommentTitle = styled(Typography)`
  max-width: fit-content;
  padding: 8px 0;
  border-bottom: 4px solid var(--secondary);
  margin-bottom: 24px;
  font: var(--regularBold);
`

const CommentsSectionStyled = styled.section`
  display: ${({ show }) => (show ? 'block' : 'none')};
  .wrapper {
    padding: 0 16px;
  }
  .comment-intersecting {
    block-size: 1px;
  }
  @media(min-width: 1024px) {
    .wrapper {
      padding: 0;
      padding-left: 24px;
    }
    display: grid;
    grid-template-columns: 1fr 30%;
    column-gap: 24px;
  }
`

function CommentsSection({ show }) {
  return (
    <CommentsSectionStyled show={show} role="region" aria-label="Seccion de comentarios">
      <div className="wrapper">
        <div className="comments-grid">
          <CommentTitle as="h2" color="var(--baseNeutral)">
            Comentarios
          </CommentTitle>
          <CommentForm cta="Comentar" placeholder="Escribe un comentario..." participants={participants} />
          <CommentList />
          <NoComments />
        </div>
      </div>
      <div className="videospacer" />
    </CommentsSectionStyled>
  )
}

export default CommentsSection
